import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {UnitModel} from '../../../unit/unit.model';

@Component({
  selector: 'app-executor-unit-list',
  templateUrl: './executor-unit-list.component.html',
  styleUrls: ['./executor-unit-list.component.scss']
})
export class ExecutorUnitListComponent implements OnInit {

  @Input() units: UnitModel[];
  @Output() deleteConfirmed = new EventEmitter<UnitModel>();

  ngOnInit() {
  }

  onDeleteConfirmed(unit) {
    this.deleteConfirmed.emit(unit);
  }
}
